import { render, staticRenderFns } from "./configurable-material.vue?vue&type=template&id=5af2f13f"
import script from "./configurable-material.vue?vue&type=script&lang=ts"
export * from "./configurable-material.vue?vue&type=script&lang=ts"
import style0 from "./configurable-material.vue?vue&type=style&index=0&id=5af2f13f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports